<template>
  <div>
    <p class='mb-5'>{{ 'uwv-decision.new-header-text' | translate }}</p>
    <report-of-sickness-card :employee="this.employee" :reportOfSickness="reportOfSickness" class='mt-5 mb-4'/>

    <form-input-container
      title='Samenvatting voor Bevestiging'
      text='De door u ingevoerde gegevens voor het doorgeven van een beslissing van UWV.'>

      <table class='confirmation-table'>
        <tr>
          <td>{{ 'uwv-decision.fields.decision-type' | translate }}</td>
          <td>{{ 'uwv-decision.types.' + newUwvDecision.decisionType | translate }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.decision-date' | translate }}</td>
          <td>{{ formatDate(newUwvDecision.decisionDate) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.start-date' | translate }}</td>
          <td>{{ formatDate(newUwvDecision.startDate) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.disability-rate' | translate }}</td>
          <td>{{ newUwvDecision.disabilityRate }}%</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.wia-monthly-wage' | translate }}</td>
          <td>{{ formatEuro(newUwvDecision.wiaMonthlyWage) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.wia-daily-wage' | translate }}</td>
          <td>{{ newUwvDecision.wiaDailyWage ? formatEuro(newUwvDecision.wiaDailyWage) : '' }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.benefit-end-date' | translate }}</td>
          <td>{{ formatDate(newUwvDecision.benefitEndDate) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.income-from-work' | translate }}</td>
          <td>{{ newUwvDecision.incomeFromWork ? formatEuro(newUwvDecision.incomeFromWork) : '' }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.attachment' | translate }}</td>
          <td>
            <span class='value' v-for="(file, i) in newUwvDecision.attachments" :key="'conf-file-'+i">{{ file.name }}</span>
          </td>
        </tr>
      </table>
    </form-input-container>

    <div style='float: right' class='mt-4'>
      <Button primary class="mr-3" @click="this.handlePreviousClick">{{ 'buttons.previous-step' | translate }}</Button>
      <Button positive @click="this.handleConfirmationClick" :disabled="isCreateUwvDecisionLoading">{{ 'uwv-decision.new-uwv-decision' | translate }}</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NewUwvDecision from '@/views/constants/uwv-decision-new';

import Helpers from '@/shared/helpers/functions';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';

import ReportOfSicknessCard from '@/views/components/reports-of-sickness/ReportOfSicknessCard.vue';

import ReportsOfSickness from '@/resources/constants/reports-of-sickness';

export default {
  name: 'NewUwvDecisionConfirmation',
  components: {
    ReportOfSicknessCard,
    FormInputContainer,
    Button
  },
  props: {
    reportOfSickness: Object,
    employee: Object
  },
  computed: {
    ...mapGetters({
      newUwvDecision: 'newUwvDecision',
      isCreateUwvDecisionLoading: 'isCreateUwvDecisionLoading'
    })
    /* isValid () {
      return this.$store.getters.newPeriodValidations.isValid() &&
        this.$store.getters.newPeriodRequiredFields.isValid();
    },
    isCreateLoading () {
      return this.$store.getters.isCreatePeriodLoading;
    } */
  },
  methods: {
    handlePreviousClick () {
      this.$store.dispatch(NewUwvDecision.Actions.Navigate.DO, NewUwvDecision.Views.Form);
    },
    handleConfirmationClick () {
      this.$store.dispatch(ReportsOfSickness.Actions.UwvDecision.Create.START,
        { reportOfSickness: this.reportOfSickness, uwvDecision: this.newUwvDecision });
    },
    formatDate (value) {
      return Helpers.Dates.formatDate(value);
    },
    formatEuro (value) {
      if (value != null) { return Helpers.Currency.formatCurrency(value.replace(',', '.')); }
    }
  }
};
</script>
